module.exports = __webpack_public_path__ + "img/sx_unit.9247d9b3.png";